import { handleUpload } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { pipe } from 'lodash/fp'

export const ensureBlackFill = (svgString: string): string => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(svgString, 'image/svg+xml')
  const paths = doc.querySelectorAll('path, circle, rect, ellipse, polygon')

  paths.forEach((path: Element) => {
    if (!path.getAttribute('fill')) {
      path.setAttribute('fill', '#000000')
    }
  })

  return new XMLSerializer().serializeToString(doc)
}

export const removeDuplicateFill = (svgString: string): string => {
  const parser = new DOMParser()
  const svgDoc = parser.parseFromString(svgString, 'image/svg+xml')
  const elements = svgDoc.querySelectorAll('*')

  elements.forEach((element) => {
    const elementString = element.outerHTML
    const fillAttrRegex = /fill="[^"]*"/g
    const fillAttrs = elementString.match(fillAttrRegex)

    if (fillAttrs && fillAttrs.length > 1) {
      element.outerHTML = elementString.replace(fillAttrs[1], '')
    }
  })

  return new XMLSerializer().serializeToString(svgDoc)
}

export const sanitizeAndUploadIcon = async (svgString: string, fileName: string): Promise<string> => {
  const sanitizedSvg = pipe(removeDuplicateFill, ensureBlackFill)(svgString)
  const blob = new Blob([sanitizedSvg], { type: 'image/svg+xml' })
  const s3Url = await handleUpload(new File([blob], fileName, { type: 'image/svg+xml' }))
  if (!s3Url) throw new Error('Failed to upload icon to S3')

  return s3Url
}
